export const cdnURL = (path, fullPath = true) => {
  let version = '';
  if (fullPath && path.indexOf(`?v=`) < 0) {
    version = '?v=1';
  }
  if (!BDAY_ENV || BDAY_ENV === 'prod') {
    return `https://birthdayalarm.com/static/${path}${version}`;
  }
  return `https://${BDAY_ENV}.birthdayalarm.com/static/${path}${version}`;
}

export const cardCdnURL = (path, fullPath = true) => {
  let version = '';
  if (fullPath && path.indexOf(`?v=`) < 0) {
    version = '?v=1';
  }
  if (!BDAY_ENV || BDAY_ENV === 'prod') {
    return `https://card.birthdayalarm.com/${path}${version}`;
  }
  return `https://card-dev.birthdayalarm.com/${path}${version}`;
}
